import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

/**
 * Composant de nœud de configuration d'entrée de fichier.
 */
export function InputNode({ id, data, handleConf, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();
  const PRIMARY_COLOR = 'infoBlue';

  const maxFilesCountLabel = msg({ id: 'field.input.maxFilesCount.label' });
  const maxFilesSizeLabel = msg({ id: 'field.input.maxFilesSize.label' });
  const allowedFileTypesLabel = msg({ id: 'field.input.allowedFileTypes.label' });
  const allowedFileTypesGroupLabel = msg({ id: 'field.input.allowedFileTypesGroup.label' });

  const formattedMaxFilesSize = data?.maxFilesSize
    ? data.maxFilesSize >= 1000
      ? `${(data.maxFilesSize / 1000).toFixed(0)} Mo`
      : `${data.maxFilesSize} Ko`
    : '-';
  const formattedAllowedFileTypes =
    data?.allowedFileTypes?.length > 0 ? data.allowedFileTypes.join(', ') : null;
  const formattedAllowedFileTypesGroup =
    data?.allowedFileTypesGroup?.length > 0
      ? data.allowedFileTypesGroup
          .map((type) => msg({ id: `field.input.allowedFileTypesGroup.${type}.label` }))
          .join(', ')
      : '';

  console.debug('input node id', id);

  return (
    <BaseNode
      id={id}
      icon="person_icon"
      nodeData={{ ...data, label: data?.label }}
      color={PRIMARY_COLOR}
      handleConf={handleConf}
      contentStyles={{
        padding: 0,
        borderRadius: 1,
        overflow: 'hidden'
      }}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <CompactNodeField
        label={maxFilesCountLabel}
        value={data?.maxFilesCount}
        color={PRIMARY_COLOR}
      />
      <CompactNodeField
        label={maxFilesSizeLabel}
        value={formattedMaxFilesSize}
        color={PRIMARY_COLOR}
      />
      {formattedAllowedFileTypes && (
        <CompactNodeField
          label={allowedFileTypesLabel}
          value={formattedAllowedFileTypes}
          color={PRIMARY_COLOR}
          shrink
        />
      )}
      {formattedAllowedFileTypesGroup && (
        <CompactNodeField
          label={allowedFileTypesGroupLabel}
          value={formattedAllowedFileTypesGroup}
          color={PRIMARY_COLOR}
          shrink
        />
      )}
    </BaseNode>
  );
}

InputNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    allowedFileTypesGroup: PropTypes.array,
    allowedFileTypes: PropTypes.array,
    maxFilesCount: PropTypes.number,
    maxFilesSize: PropTypes.number
  }),
  handleConf: PropTypes.array.isRequired,
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
